(function (w, d) {
    if (w.videoObj)
        return;

    var _getData = function (url) {
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open("GET", url, false); // false for synchronous request
        xmlHttp.send(null);
        return JSON.parse(xmlHttp.responseText);
    };

    var adUnitURL = function (element) {
        var settings = {
            DFPURL: "https://pubads.g.doubleclick.net/gampad/ads?",
            adUnit: "/6870/ynet/video_desktop/",
            dcPath: "8.Central-1.Home"
        };
        var objectToURL = function (obj) {
            var pairs = [];
            for (var prop in obj) {
                if (!obj.hasOwnProperty(prop)) {
                    continue;
                }
                if (Object.prototype.toString.call(obj[prop]) == '[object Object]') {
                    pairs.push(prop + "=" + encodeURIComponent(objectToURL(obj[prop])));
                    continue;
                }
                pairs.push(prop + "=" + obj[prop]);
            }
            return pairs.join('&');
        };
        var prerollTag = {
            sz: "640x480|640x360",
            iu: element.dataset.adunit ? element.dataset.adunit : settings.adUnit,
            impl: "s",
            gdfp_req: 1,
            env: "vp",
            output: "vast",
            unviewed_position_start: 1,
            url: "[referrer_url]",
            description_url: encodeURIComponent(window.location.href),
            correlator: "[timestamp]",
            cust_params: {
                VideoPosition: "Preroll",
                dcPath: window.dcPath ? window.dcPath : settings.dcPath,
                autoplay: false,
                VideoPosition_autoplay: false,
                view: updateAdViewData.get(element)
            }
        }
        console.log(settings.DFPURL + objectToURL(prerollTag));
        return settings.DFPURL + objectToURL(prerollTag);
    };

    var updateAdViewData = {
        get: element => {
            if (!Boolean(Storage)) return;
            return window.localStorage.getItem(element.id);
        },
        set: element => {
            if (!Boolean(Storage)) return;
            var videoTag = element.querySelector("video");
            var stateBusy = false;
            videoTag.ontimeupdate = function () {
                if (parseInt(videoTag.currentTime) == 3 && !stateBusy) {
                    stateBusy = true;
                    if (window.localStorage.getItem(element.id)) {
                        window.localStorage.setItem(element.id, parseInt(window.localStorage.getItem(element.id)) + 1)
                    } else {
                        window.localStorage.setItem(element.id, 1)
                    }
                }
            }
        }
    }

    var playersScripts = {
        youtube: [{
            type: "stylesheet",
            src: "//ynet.co.il/Common/Api/Scripts/youtube/youtube.css?v=0.6",
            id: "ynet_youtube"
        },
        {
            type: "script",
            src: "//www.youtube.com/player_api",
            id: "ynet_youtube_js_2"
        },
        {
            type: "script",
            src: "//ynet.co.il/Common/Api/Scripts/youtube/youtube.js?v=0.6",
            id: "ynet_youtube_js"
        }
        ],
        hola: [{
            type: "script",
            src: "//player2.h-cdn.com/hola_player.js?customer=ynet",
            id: "hola"
        }]
    }

    var initPlayerObject = function (players, scripts, callback) {
        var obj = {
            players: players,
            scripts: scripts,
            callback: callback
        }
        return obj;
    }

    var initPlayers = function (playerObject) {
        playerObject.scripts.forEach(function (script, index) {
            loadTags(script.type, script.src, script.id, index + 1 === playerObject.scripts.length ? playerObject.callback : undefined);
        });
    }
    var addHolaVideo = function (holaPlayers) {
        holaPlayers.forEach(function (element) {
            var videoData = _getData("https://www.ynet.co.il/3rdparty/mobile/json/video/" + element.id.split('_')[1] + "/");
            var video = document.createElement('video');
            video.id = "hola_" + videoData[0].id;
            video.preload = "none";
            video.className = "video-js vjs-default-skin";
            video.poster = videoData[0].poster_image;
            video.controls = "controls";
            video.style.width = "100%";
            video.style.height = "100%";
            var sourceMP4 = document.createElement("source");
            sourceMP4.src = videoData[0].mobile;
            video.appendChild(sourceMP4);
            document.getElementById(element.id).appendChild(video);
            window.hola_player({
                player: "#hola_" + videoData[0].id,
                ads: {
                    adTagUrl: adUnitURL(element)
                }
            });
            updateAdViewData.set(element);

            window.spark_conf = {
                enable_events: true,
                debug: true,
            };
        });
    }
    var addYouTubeVideo = function (youTubePlayers) {
        youTubePlayers.forEach(function (element) {
            var videoData = _getData("https://www.ynet.co.il/3rdparty/mobile/json/video/" + element.id.split('_')[1] + "/");
            var video_block = {
                id: element.id,
                height: '100%',
                width: '100%',
                videoId: videoData[0].youtube_id,
                FlpATfPrcntg: '1',
                autoplay: 0,
                playerVars: {
                    autoplay: 0,
                    loop: 0,
                    controls: 1,
                    showinfo: 0,
                    autohide: 1,
                    modestbranding: 1,
                    rel: 1,
                    vq: 'hd1080',
                    hl: 'he'
                },
                events: {
                    'onStateChange': window.YnetYoutube.onPlayerStateChange,
                    'onReady': window.YnetYoutube.onPlayerReady,
                },
                embedConfig: {
                    autonavRelatedVideos: true
                }
            };
            window.YnetYoutube.playerInfoList.push(video_block);
            window.YT.ready(window.YnetYoutube.onYouTubeIframeAPIReady);

        });
    }

    var loadTags = function (tagType, src, id, callback) {
        var tag;
        // if (!document.getElementById(id)) {
        //     if (tagType === 'stylesheet') {
        //         tag = document.createElement('link');
        //         tag.rel = 'stylesheet';
        //         tag.href = src;
        //     } else {
        //         tag = document.createElement(tagType);
        //         tag.src = src;
        //         tag.async = false;
        //         tag.defer = false
        //     }
        //     tag.id = id;
        //     if (callback) {
        //         if (tag.readyState) { //IE
        //             tag.onreadystatechange = function () {
        //                 if (tag.readyState === "loaded" || tag.readyState === "complete") {
        //                     tag.onreadystatechange = null;
        //                     callback();
        //                 }
        //             };
        //         } else { //Others
        //             tag.onload = function () {
        //                 callback();
        //             };
        //         }
        //     }
        //     document.head.appendChild(tag);
        // } else {
        if (callback)
            callback();
        // }
    }

    w.videoObj = function () {
        var _this = {
            initVideo: function (isYouTube) {
                var allPlayers = Array.prototype.slice.call(document.querySelectorAll("[id*='ynetPlayer']"));
                if (allPlayers.length > 0) {
                    var youTubePlayers = [];
                    var holaPlayers = [];
                    allPlayers.forEach(function (element) {
                        if (element.dataset.playertype) {
                            switch (element.dataset.playertype) {
                                case "youtube":
                                    youTubePlayers.push(element);
                                    break;
                                case "hola":
                                    holaPlayers.push(element);
                                    break;
                                default:
                                    youTubePlayers.push(element);
                                    break;
                            }
                        } else {
                            youTubePlayers.push(element);
                        }
                    });
                    if (youTubePlayers.length > 0) {
                        var playerObject = initPlayerObject(youTubePlayers, playersScripts.youtube, function () {
                            addYouTubeVideo(youTubePlayers)
                        });
                        initPlayers(playerObject);
                    }
                    if (holaPlayers.length > 0) {
                        var playerObject = initPlayerObject(holaPlayers, playersScripts.hola, function () {
                            addHolaVideo(holaPlayers)
                        });
                        initPlayers(playerObject);
                    }
                }
            },

            // setPrerollTag: function (prerollTagText) {
            //     prerollTag = prerollTagText;
            // }
        }
        return _this;
    };
})(window, document);

var videoObj = window.videoObj();



// WEBPACK FOOTER //
// ./src/static/videoApi.js